module.exports = __webpack_public_path__ + "img/Group 4.cf7e67e2.png";